import React from 'react';
import { HardHat, Briefcase, Building, Landmark } from 'lucide-react';
import { targetAudience } from '../../data/mock';

const iconMap = {
  HardHat: HardHat,
  Briefcase: Briefcase,
  Building: Building,
  Landmark: Landmark
};

const TargetAudienceSection = () => {
  return (
    <section className="py-12 sm:py-16 lg:py-24 bg-white">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        {/* Section Header */}
        <div className="text-center mb-10 sm:mb-16">
          <span className="inline-block px-3 py-1 rounded-full bg-slate-100 text-slate-700 text-xs sm:text-sm font-medium mb-3 sm:mb-4 border border-slate-200">
            Für wen ist das?
          </span>
          <h2 className="text-xl sm:text-2xl md:text-3xl font-semibold text-slate-800 mb-3 sm:mb-4">
            Unsere Zielgruppe
          </h2>
          <p className="text-sm sm:text-base text-slate-600 max-w-2xl mx-auto px-4">
            Egal ob Neubau oder Bestandsquartier – wir skalieren das Modell auf Ihr Projekt.
          </p>
        </div>

        {/* Target Audience Cards */}
        <div className="grid grid-cols-2 lg:grid-cols-4 gap-3 sm:gap-6">
          {targetAudience.map((target, index) => {
            const Icon = iconMap[target.icon];
            return (
              <div 
                key={index}
                className="group p-4 sm:p-6 rounded-xl bg-slate-50 border border-slate-200 hover:border-cyan-300 hover:shadow-sm transition-all text-center"
              >
                <div className="w-12 h-12 sm:w-14 sm:h-14 rounded-xl bg-white border border-slate-200 shadow-sm flex items-center justify-center mx-auto mb-3 sm:mb-4 group-hover:border-cyan-300 transition-colors">
                  <Icon className="w-6 h-6 sm:w-7 sm:h-7 text-cyan-700" />
                </div>
                
                <h3 className="text-sm sm:text-base font-semibold text-slate-800 mb-1 sm:mb-2">{target.title}</h3>
                <p className="text-xs sm:text-sm text-slate-600 hidden sm:block">{target.description}</p>
              </div>
            );
          })}
        </div>
      </div>
    </section>
  );
};

export default TargetAudienceSection;
